import { Flex, Paper, Text, Switch, Center } from '@mantine/core';

import { useState } from 'react';

import { toActionSetting } from '../model/index.ts';

import { MessageFormValue } from '#/components/ui/messages/model/messageForm.ts';

import { ActionSettingPreview } from './actionEditor/ActionSetting/ActionSettingPreview.tsx';
import { PushNotiPreview } from './PushNoti/index.ts';

// eslint-disable-next-line unused-imports/no-unused-vars
const PreviewSwitcher = ({
  current,
  setCurrent,
}: {
  type: string;
  current: 'noti' | 'action';
  setCurrent: (v: 'noti' | 'action') => void;
}) => {
  return (
    <Flex align={'center'} gap={5}>
      <Text>推播</Text>

      <>
        <Switch
          checked={current === 'action'}
          onChange={() => {
            setCurrent(current === 'action' ? 'noti' : 'action');
          }}
        />
        <Text>行為</Text>
      </>
    </Flex>
  );
};

export const TemplatePreview = ({ value }: { value: MessageFormValue }) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [current, setCurrent] = useState<'noti' | 'action'>('noti');

  const content = (() => {
    if (current === 'noti') {
      return <PushNotiPreview value={value} />;
    }

    return (
      <ActionSettingPreview value={toActionSetting(value.actionSetting)} />
    );
  })();

  return (
    <Paper
      withBorder
      bg="gray.0"
      p="md"
      radius="md"
      mih={300}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
      }}
    >
      <Center className="grow">{content}</Center>
    </Paper>
  );
};
